<template>
  <div class="dropdown-expand" :class="{ 'dropdown-expand--is-open': isOpen }">
    <button
      class="dropdown-expand__toggler"
      :class="togglerClass"
      :aria-expanded="isOpen"
      :aria-controls="contentId"
      type="button"
      @click="toggleAccordion()">
      <slot name="toggler"></slot>
      <oie-use-svg v-if="!useCaret" svg="circle-plus" :class="['dropdown-expand__toggler-icon', {'svg--45': isOpen}]"></oie-use-svg>
      <oie-use-svg v-if="useCaret" svg="caret" :class="['dropdown-expand__toggler-icon dropdown-expand__toggler-icon--caret svg--90', {'svg--90-negative': isOpen}]"></oie-use-svg>
    </button>

    <div
      v-show="isOpen"
      :id="contentId"
      :class="['dropdown-expand__content', { 'dropdown-expand__content--is-open': isOpen }, contentClass, { 'dropdown-expand__content--padding': useCaret }]">
      <slot name="content"></slot>
    </div>
  </div>
</template>

<script>
import accordion from '@/mixins/accordion.js'
import { uniqueId } from 'lodash'

export default {
  mixins: [accordion],
  props: {
    togglerClass: {
      type: String,
      default: ''
    },
    contentClass: {
      type: String,
      default: ''
    },
    useCaret: {
      type: Boolean,
      default: false
    },
    manualToggle: {
      type: Boolean,
      default: null
    }
  },
  data() {
    return {
      contentId: uniqueId('dropdown-content-')
    }
  }

}
</script>

<style lang="scss">
.dropdown-expand__toggler {
  @include reset-button;
  @include body-semi-bold;
  display: flex;
  align-items: center;
  width: 100%;
  height: 3.125rem;
  padding: 0 measure(quarter);
}

.dropdown-expand__toggler-icon {
  margin-left: auto;
}

.dropdown-expand__toggler-icon--caret {
  width: 0.4375rem;
  height: 0.8125rem;
}

.dropdown-expand__content {
  display: none;
}

.dropdown-expand__content--is-open {
  display: block;
}

.dropdown-expand__content--padding {
  padding: measure(double);
}
</style>
